import { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { decodeToken, isExpired } from 'react-jwt';
import StaticVar from 'config/StaticVar';
import jwtDecode from 'jwt-decode';
import { getToken } from 'firebase/messaging';
import Api from 'services/api';

import { messaging, vapidKey } from 'config/firebaseConfig';
import API from 'services/api';

const getAccessTokenFromLocalStorage = () => {
	return localStorage.getItem('access_token');
};

const getRefreshTokenFromLocalStorage = () => {
	return localStorage.getItem('refresh_token');
};

const removeTokensFromLocalStorage = () => {
	localStorage.removeItem('access_token');
	localStorage.removeItem('refresh_token');
	localStorage.removeItem('google_token');
	localStorage.removeItem('google_id_token');
	localStorage.removeItem('gmail_token');
	localStorage.removeItem('gmail_id_token');
	localStorage.removeItem('google_refresh_token');
	localStorage.removeItem('google_expiry_date');
};

export const UserContext = createContext({});

const UserProvider = props => {
	const navigate = useNavigate();
	const [isAuth, setIsAuth] = useState(!!localStorage.getItem('refresh_token'));
	const [accessToken, setAccessToken] = useState(null);
	const [refreshToken, setRefreshToken] = useState(null);
	const [dataUser, setDataUser] = useState({});
	const [dataUserGoogle, setDataUserGoogle] = useState(null);
	const [dataUserGmail, setDataUserGmail] = useState(null);

	const getDataUser = async () => {
		const token = localStorage.getItem('access_token');
		let tokenGoogle = localStorage.getItem('google_token');

		if (token) {
			const _isExpired = isExpired(token);
			if (!_isExpired) {
				const _decodedToken = decodeToken(token);
				let iduser = _decodedToken?.id;
				let res = await Api.getUser(iduser);
				let resdata = await res?.data;
				let picID = await resdata?.picID;
				let dataUri = null;
				if (picID && tokenGoogle) {
					let img64 = await API.getFile({ token: tokenGoogle, id: picID });
					dataUri = await img64?.data;
				}

				delete resdata._id;
				setDataUser({ ..._decodedToken, ...resdata, dataUri });
				return { ..._decodedToken, ...resdata, dataUri };
			} else {
				console.log('verifyrefreshtoken');
				verifyRefreshToken();
			}
		}
	};
	const getDataUserGoogle = () => {
		const token = localStorage.getItem('google_id_token');
		if (token) {
			const _decodedToken = jwtDecode(token);
			setDataUserGoogle(_decodedToken);
			return _decodedToken;
		}
	};

	const getDataUserGmail = () => {
		const token = localStorage.getItem('gmail_id_token');
		if (token) {
			const _decodedToken = jwtDecode(token);
			setDataUserGmail(_decodedToken);
			return _decodedToken;
		}
	};

	const saveTokensToLocalStorage = (type, token) => {
		if (type === 'access_token') {
			localStorage.setItem(type, token);
			setAccessToken(token);
		}
		if (type === 'refresh_token') {
			localStorage.setItem(type, token);
			setRefreshToken(token);
		}
	};

	const roleTopicMap = {
		'eFiling LN': ['DraftedEfilingLN'],
		'eFiling DN': ['DraftedEfilingDN'],
		'Filing Report LN': ['SubmittedEfilingLN'],
		'Publikasi LN': ['SubmittedEfilingLN'],
		'Publikasi DN': ['SubmittedEfilingDN'],
		'Status LN': ['SubmittedPublikasiLN', 'DraftedStatusLN'],
		'Status DN': ['SubmittedPublikasiDN', 'DraftedStatusDN'],
		'Sertifikat LN': ['SubmittedStatusLN'],
		'Renewal LN': ['DraftedRenewalLN'],
		'Renewal DN': ['DraftedRenewalDN'],
		'Recordal LN': ['DraftedRecordalLN'],
		'Recordal DN': ['DraftedRecordalDN'],
		// patent
		'eFiling Patent': ['draftedPatentEfiling', 'duePatentEfiling'],
		'Formalitas Patent': ['draftedPatentFormalitas', 'duePatentFormalitas'],
		'Publikasi Patent': ['draftedPatentPublikasi', 'duePatentPublikasi'],
		'Substantive Patent': ['draftedPatentSubstantive', 'duePatentSubstantive'],
		'Office Action Patent': ['draftedPatentOA', 'duePatentOA'],
		'Registrasi Patent': ['draftedPatentRegistrasi', 'duePatentRegistrasi'],
		'Sertifikat Patent': ['draftedPatentSertifikat', 'duePatentSertifikat'],
		'Recordal Patent': ['draftedPatentRecordal', 'duePatentRecordal'],
		'Renewal Patent': ['draftedPatentRenewal', 'duePatentRenewal'],
	};

	const getTopicsForRoles = roles => {
		const topics = new Set(); // Using a Set to avoid duplicate topics

		roles.forEach(role => {
			const mappedTopics = roleTopicMap[role];
			if (mappedTopics) {
				mappedTopics.forEach(topic => topics.add(topic));
			}
		});

		return Array.from(topics); // Convert Set to Array
	};

	const manageSubscription = async ({ topic, fcm, action }) => {
		try {
			const bodySub = {
				topic,
				token: [fcm],
			};
			if (action === 'subscribe') {
				await Api.subScribeToTopic(bodySub);
			} else if (action === 'unsubscribe') {
				await Api.unSubscribeToTopic(bodySub);
			}
			return topic;
		} catch (error) {
			throw new Error(error);
		}
	};

	const updateFCMTokens = decoded => {
		getToken(messaging, { vapidKey })
			.then(async fcm => {
				console.log('update fcm true', fcm);
				const froles = decoded?.roles?.map(x => x?.name) || [];
				const isAdmin = froles.some(x => x === 'Admin');
				const topicsToSubscribe = getTopicsForRoles(froles);
				const allTopics = Object.values(roleTopicMap).flat();
				const topicsToUnsubscribe = allTopics.filter(
					topic => !topicsToSubscribe.includes(topic)
				);

				console.log('topicsToSubscribe', topicsToSubscribe);

				try {
					await Api.putFCM(decoded.id, { fcmtoken: fcm });
					if (!isAdmin) {
						const subscribePromises = topicsToSubscribe.map(topic =>
							manageSubscription({ topic, fcm, action: 'subscribe' })
						);
						await Promise.all(subscribePromises);

						const unsubscribePromises = topicsToUnsubscribe.map(topic =>
							manageSubscription({ topic, fcm, action: 'unsubscribe' })
						);
						await Promise.all(unsubscribePromises);

						console.log('All topics managed successfully');
					}
				} catch (error) {
					console.log('subscribe topic failed');
				}
			})
			.catch(err => {
				console.log('Update fcm failed!', err);
				// toast.error("")
			});
	};

	const login = (data, type) => {
		return axios({
			url: '/auth/login',
			baseURL: StaticVar.URL_API,
			method: 'post',
			// headers: { "Content-Type": "application/x-www-form-urlencoded" },
			data: data,
		})
			.then(res => {
				const _accessToken = res.data.accessToken;
				const _refreshToken = res.data.refreshToken;
				saveTokensToLocalStorage('access_token', _accessToken);
				saveTokensToLocalStorage('refresh_token', _refreshToken);
				setIsAuth(true);

				var decoded = jwtDecode(_accessToken);

				const currentPermission = Notification.permission;
				console.log('currentPermission', currentPermission);

				if (currentPermission !== 'granted') {
					Notification.requestPermission().then(permission => {
						if (permission === 'granted') {
							console.log('permission granted');
							// always update fcmtoken user
							updateFCMTokens(decoded);
						} else {
							console.log('permission denied');
							return;
						}
					});
				} else {
					updateFCMTokens(decoded);
				}

				return res;
				// navigate("/");
			})
			.catch(err => {
				console.log('err', err);
				alert(err.response.data.message);

				throw Error('Login failed! Please check your email or password');
			});
	};

	const ssoGoogle = async code => {
		const tokenResponse = await axios.post(StaticVar.URL_API + '/auth/google', {
			code,
		});
		//backend that will exchange the code
		localStorage.setItem('google_token', tokenResponse.data?.access_token);
		localStorage.setItem('google_id_token', tokenResponse.data?.id_token);
		localStorage.setItem(
			'google_refresh_token',
			tokenResponse.data?.refresh_token
		);
		localStorage.setItem('google_expiry_date', tokenResponse.data?.expiry_date);
		localStorage.setItem('gmail_token', tokenResponse.data?.access_token);
		localStorage.setItem('gmail_id_token', tokenResponse.data?.id_token);
		var decoded = jwtDecode(tokenResponse.data?.id_token);
		return login({ email: decoded?.email });
	};

	const ssoGmail = async code => {
		const tokenResponse = await axios.post(StaticVar.URL_API + '/auth/google', {
			code,
		});
		//backend that will exchange the code
		localStorage.setItem('gmail_token', tokenResponse.data?.access_token);
		localStorage.setItem('gmail_id_token', tokenResponse.data?.id_token);
		// localStorage.setItem("google_token", tokenResponse.data?.access_token)
		// localStorage.setItem("google_id_token", tokenResponse.data?.id_token)
		return { status: 200 };
	};

	const checkExpiration = () => {
		const _accessToken = getAccessTokenFromLocalStorage();
		const _refreshToken = getRefreshTokenFromLocalStorage();

		if (_refreshToken && _accessToken) {
			const isRefreshTokenExpired = isExpired(_refreshToken);
			if (isRefreshTokenExpired) {
				logout();
			} else {
				setIsAuth(true);
			}
		} else {
			logout();
		}
	};

	const verifyRefreshToken = () => {
		console.log('usercontext refreshtoken');
		const data = { refreshToken: localStorage.refresh_token };
		axios
			.post(`${StaticVar.URL_API}/auth/refresh`, data)
			.then(refresh => {
				const newAccesToken = refresh.data.accessToken;
				const newRefreshToken = refresh.data.refreshToken;
				// udpate tokens
				localStorage.setItem('access_token', newAccesToken);
				localStorage.setItem('refresh_token', newRefreshToken);

				setIsAuth(true);
				window.location.reload();
			})
			.catch(error => {
				console.log(error);
				logout();
			});
	};

	const logout = () => {
		removeTokensFromLocalStorage();
		setAccessToken(null);
		setRefreshToken(null);
		setIsAuth(false);
		// window.location.reload()
	};

	return (
		<UserContext.Provider
			value={{
				isAuth,
				accessToken,
				refreshToken,
				dataUser,
				login,
				logout,
				checkExpiration,
				verifyRefreshToken,
				getDataUser,
				setDataUser,
				ssoGoogle,
				ssoGmail,
				getDataUserGoogle,
				dataUserGoogle,
				setDataUserGoogle,
				getDataUserGmail,
				setDataUserGmail,
				dataUserGmail,
			}}
			{...props}
		/>
	);
};

export default UserProvider;
